
const angular = require('angular')

angular.module('clientDashboardApp').factory('reviewResponseTemplateService', function($http, providerService, userService) {

  return {

    listTemplates: function() {
      return $http.get("/reviewResponseTemplates").then(response => {
        return response.data
      })
    },

    deleteTemplate: function(id) {
      $http.delete(`/reviewResponseTemplates/${id}`)
    },

    updateTemplate: function(id, name, body, sentimentType) {
      $http.post(`/reviewResponseTemplates/${id}`, {name: name, body: body, sentimentType: sentimentType}).then(response => {
        return response.data
      })
    },

    createTemplate: function(name, body, sentimentType) {
      return $http.post(`/reviewResponseTemplates`, {
        name: name,
        body: body,
        sentimentType: sentimentType}).then(response => {
        return response.data
      })
    }
  }

})
